if (!customElements.get('gg-jump-to-game')) {
  customElements.define('gg-jump-to-game', class extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      if (!this.tabs.length) return;
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.select(i));
        tab.addEventListener('keydown', (e) => {
          const step = { ArrowRight: 1, ArrowLeft: -1 }[e.key];
          const n = this.tabs.length;
          const next = step ? (i + step + n) % n : e.key === 'Home' ? 0 : e.key === 'End' ? n - 1 : -1;
          if (next < 0) return;
          e.preventDefault();
          this.select(next);
          this.tabs[next].focus();
        });
      });
      // Theme editor: selecting a system block shows its tab.
      this.addEventListener('shopify:block:select', (e) => {
        const panel = e.target.closest('[role="tabpanel"]');
        const i = panel
          ? this.tabs.findIndex((t) => t.getAttribute('aria-controls') === panel.id)
          : this.tabs.indexOf(e.target.closest('[role="tab"]'));
        if (i >= 0) this.select(i);
      });
    }

    select(index) {
      this.tabs.forEach((tab, i) => {
        const on = i === index;
        tab.setAttribute('aria-selected', on);
        tab.tabIndex = on ? 0 : -1;
        document.getElementById(tab.getAttribute('aria-controls')).hidden = !on;
      });
    }
  });
}
